import { Link } from 'react-router-dom';
import { Hero } from '../components/Hero';
import './Legal.css';

export function PrivacyPolicy() {
  return (
    <div className="legal">
      <Hero
        title="Privacy Policy"
        subtitle="How we collect, use, and protect your information"
        size="small"
      />

      <section className="legal__content">
        <div className="container container--narrow">
          <p className="legal__meta">
            <strong>Effective Date:</strong> February 26, 2026 &nbsp;|&nbsp;{' '}
            <strong>Last Updated:</strong> February 26, 2026
          </p>

          <p className="legal__intro">
            Notation of Being LLC ("we," "us," or "our") operates{' '}
            <a href="https://www.notationofbeing.com">https://www.notationofbeing.com</a> (the "Site").
            This Privacy Policy explains how we collect, use, disclose, and safeguard your information
            when you visit our Site, subscribe to our emails, or contact us.
          </p>
          <p className="legal__intro">
            By using this Site, you consent to the practices described in this policy.
          </p>

          <h2>1. Information We Collect</h2>
          <p>We may collect the following types of information:</p>

          <p><strong>Information You Voluntarily Provide</strong></p>
          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Messages submitted via contact forms</li>
            <li>Any other information you choose to provide</li>
          </ul>

          <p><strong>Automatically Collected Information</strong></p>
          <ul>
            <li>IP address</li>
            <li>Browser type</li>
            <li>Device information</li>
            <li>Pages visited</li>
            <li>Referring URLs</li>
            <li>Interaction data</li>
          </ul>
          <p>
            We may use cookies or similar technologies to improve user experience and site performance.
          </p>

          <h2>2. How We Use Your Information</h2>
          <p>We may use collected information to:</p>
          <ul>
            <li>Respond to inquiries submitted via contact form</li>
            <li>Send newsletters or updates if you subscribe</li>
            <li>Improve website performance and content</li>
            <li>Monitor usage trends</li>
            <li>Maintain site security</li>
            <li>Comply with legal obligations</li>
          </ul>
          <p>We do not sell your personal information.</p>

          <h2>3. Email Communications</h2>
          <p>If you subscribe to our mailing list:</p>
          <ul>
            <li>
              You consent to receive periodic emails related to Notation of Being content, blog
              updates, announcements, or related material.
            </li>
            <li>
              You may unsubscribe at any time using the link provided in emails.
            </li>
            <li>
              We use third-party email service providers (currently{' '}
              <a href="https://resend.com" target="_blank" rel="noopener noreferrer">Resend</a>
              ) to deliver emails. These providers may process your information on our behalf solely
              for email distribution and infrastructure purposes.
            </li>
            <li>
              We may change providers in the future. All providers are required to maintain
              reasonable security standards.
            </li>
          </ul>

          <h2>4. Third-Party Services</h2>
          <p>
            We may use third-party services to operate the Site, including but not limited to:
          </p>
          <ul>
            <li>Email delivery providers (e.g., Resend)</li>
            <li>Website hosting providers</li>
            <li>Analytics tools</li>
            <li>Payment processors (if applicable in the future)</li>
          </ul>
          <p>
            These third parties may have access to limited personal data only as necessary to
            perform their services and are obligated not to disclose or use it for unrelated purposes.
          </p>

          <h2>5. Data Retention</h2>
          <p>
            We retain submitted contact and subscription information as long as reasonably
            necessary to:
          </p>
          <ul>
            <li>Fulfill communication purposes</li>
            <li>Comply with legal obligations</li>
            <li>Maintain business records</li>
          </ul>
          <p>
            You may request deletion of your personal data by contacting us at{' '}
            <a href="mailto:contact@notationofbeing.com">contact@notationofbeing.com</a>.
          </p>

          <h2>6. Security</h2>
          <p>
            We implement reasonable technical and administrative safeguards to protect personal
            information. However, no method of transmission over the Internet is 100% secure.
          </p>
          <p>Use of the Site is at your own risk.</p>

          <h2>7. Children's Privacy</h2>
          <p>
            This Site is not directed toward children under 13. We do not knowingly collect
            personal information from children.
          </p>
          <p>
            If you believe a child has submitted information, please contact us immediately.
          </p>

          <h2>8. Your Rights</h2>
          <p>Depending on your jurisdiction, you may have rights to:</p>
          <ul>
            <li>Access your data</li>
            <li>Request correction</li>
            <li>Request deletion</li>
            <li>Withdraw consent</li>
          </ul>
          <p>
            To exercise any rights, contact:{' '}
            <a href="mailto:contact@notationofbeing.com">contact@notationofbeing.com</a>
          </p>

          <h2>9. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy periodically. Updates will be posted on this page
            with a revised effective date.
          </p>
          <p>
            Continued use of the Site constitutes acceptance of any modifications.
          </p>

          <h2>10. Contact</h2>
          <address className="legal__address">
            <strong>Notation of Being LLC</strong><br />
            Email: <a href="mailto:contact@notationofbeing.com">contact@notationofbeing.com</a><br />
            Website: <a href="https://www.notationofbeing.com">https://www.notationofbeing.com</a>
          </address>

          <p>
            <Link to="/terms">View our Terms of Use</Link>
          </p>
        </div>
      </section>
    </div>
  );
}
